import React from "react";
import { useRecoilState } from "recoil";
import { confirmState, ConfirmType } from "../../recoil/confirm";
import styled from "styled-components";

const ConfirmRecoilModal: React.FC = () => {
  const [confirmStates, setConfirmStates] =
    useRecoilState<ConfirmType>(confirmState);

  const closeModal = () => {
    setConfirmStates((prev) => ({
      ...prev,
      visibleConfirm: false,
      handleConfirm: null,
      title: "",
      successText: "",
      cancelText: "",
    }));
  };

  const handleConfirm = () => {
    closeModal();

    if (confirmStates.handleConfirm) {
      confirmStates.handleConfirm();
    }
  };

  return (
    <Style>
      {confirmStates.visibleConfirm && (
        <div className="modalWrap">
          <div className="modal">
            <img
              className="closeIcon"
              onClick={closeModal}
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
              alt="닫기 아이콘"
            />

            <p className="titleFont">{confirmStates.title}</p>
            <div className="bottomButtonWrap">
              <div className="cancelButton" onClick={closeModal}>
                {confirmStates.cancelText}
              </div>

              <div className="confirmButton" onClick={handleConfirm}>
                {confirmStates.successText}
              </div>
            </div>
          </div>
        </div>
      )}
    </Style>
  );
};

export default ConfirmRecoilModal;

const Style = styled.div`
  .modalWrap {
    width: 100%;
    min-height: 100vh;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999999;
    background: rgba(0, 0, 0, 0.5);
  }
  .modal {
    width: 65vw;
    padding: 32px 35px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    background: #343434;
  }

  .closeIcon {
    position: absolute;
    top: 5%;
    right: 4%;
    cursor: pointer;
  }

  .titleFont {
    padding: 27px 30px;
    font-size: 22px;
    line-height: 38px;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
  }

  .bottomButtonWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .cancelButton {
      width: 100%;
      padding: 16px;
      font-size: 24px;
      line-height: 32px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #555555;
      background: #e5e5e5;
      border: 1px solid #e5e5e5;
    }

    .confirmButton {
      width: 100%;
      padding: 16px;
      font-size: 24px;
      line-height: 32px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #ffffff;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
  }
`;
